import { useState } from "react";
import { api, type AuthUser } from "@/lib/api";

interface Props {
  onClose: () => void;
  onSave: (user: AuthUser) => void;
}

export default function StudentModal({ onClose, onSave }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
    company: "",
    phone: "",
    role: "estudiante",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const saved = await api.createUser(formData);
      onSave(saved);
      onClose();
    } catch (err: any) {
      setError(err.message || "Error al crear estudiante");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-[fadeIn_0.2s_ease-out]">
      <div className="bg-[var(--color-bg-card)] rounded-2xl w-full max-w-md overflow-hidden border border-[var(--color-border)] shadow-2xl flex flex-col max-h-[90vh]">
        <div className="flex items-center justify-between p-5 border-b border-[var(--color-border)]">
          <h2 className="text-xl font-bold text-[var(--color-text-primary)]">
            Añadir Estudiante
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-[var(--color-bg-tertiary)] rounded-lg transition-colors cursor-pointer">
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="p-5 overflow-y-auto flex-1 custom-scrollbar">
          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-400 p-3 rounded-lg text-sm mb-4">
              {error}
            </div>
          )}

          <form id="student-form" onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-1">Nombre Completo *</label>
              <input type="text" name="full_name" value={formData.full_name} onChange={handleChange} required className="input-field" placeholder="Ej. Juan Pérez" />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-1">Correo Electrónico *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required className="input-field" placeholder="correo@ejemplo.com" />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-1">Contraseña Provisional *</label>
              <input type="password" name="password" value={formData.password} onChange={handleChange} required minLength={6} className="input-field" placeholder="Mínimo 6 caracteres" />
              <p className="text-xs text-[var(--color-text-muted)] mt-1">El estudiante usará esta contraseña para iniciar sesión.</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-1">Empresa</label>
              <input type="text" name="company" value={formData.company} onChange={handleChange} className="input-field" placeholder="Opcional" />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-1">Teléfono</label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="input-field" placeholder="Opcional" />
            </div>
          </form>
        </div>

        <div className="p-5 border-t border-[var(--color-border)] bg-[var(--color-bg-tertiary)] flex justify-end gap-3">
          <button type="button" onClick={onClose} className="btn-secondary">Cancelar</button>
          <button type="submit" form="student-form" disabled={loading} className="btn-primary">
            {loading ? "Creando..." : "Crear Estudiante"}
          </button>
        </div>
      </div>
    </div>
  );
}
